/* eslint-disable */
/* istanbul ignore file */
import React, { type Dispatch, useState } from 'react'
import { Grid, CardContent, IconButton, CircularProgress } from '@mui/material'
import DefaultImage from '../../../assets/No-Image.png'
import LanguageStrings from '../../../i18n/locales'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { gatewayDeleteCampaign } from '../../gateway-management/redux/actionCreators'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import GenericModal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import { type RootState } from '../../../store'
import moment from 'moment-timezone'
import { Tooltip } from '@mui/material'

const GatewayInformationStrings = LanguageStrings().DeviceManagementCollectionStrings.GatewayInformationComponent
const httpStatus = APIConfiguration

const GatewayInformation = (props: PropsFromRedux & { parentSiteId: any, deviceAssetId: any, gatewayInfo: any, imageBinaryData: any }): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()
  const [selectedGatewayId, setSelectedGatewayId] = useState('')
  const [confirmDeletePopup, setConfirmDeletePopup] = useState(false)
  const [showDeleteStatus, setShowDeleteStatus] = useState(false)
  const gatewayDeleteStatus = useSelector(
    (state: RootState) => state.gatewayDeleteState
  )
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  /* istanbul ignore next */
  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }

  /* istanbul ignore next */
  const handleEdit = (): void => {
    navigate(`/edit-gateway/${props.gatewayInfo.gatewayInfo.id}`, {
      state: {
        parentSiteId: props.parentSiteId,
        deviceAssetId: props.deviceAssetId
      }
    })
  }

  /* istanbul ignore next */
  const handleDelete = (): void => {
    setSelectedGatewayId(props.gatewayInfo.gatewayInfo.id)
    setConfirmDeletePopup(true)
    setAnchorEl(null)
  }

  /* istanbul ignore next */
  const handleDeleteCampaign = (): void => {
    setConfirmDeletePopup(false)
    setShowDeleteStatus(true)
    props.gatewayDeleteCampaign(selectedGatewayId)
  }

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 40) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 40)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const handleDeleteCampaignWithFailure = (): JSX.Element => {
    /* istanbul ignore next */
    if (gatewayDeleteStatus.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={GatewayInformationStrings.successfullyDeleted}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/gateway-list/${props.deviceAssetId}`, { state: { parentSiteId: props.parentSiteId } }) // Redirect after closing the modal
          }}
          onClose={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/gateway-list/${props.deviceAssetId}`, { state: { parentSiteId: props.parentSiteId } }) // Redirect after closing the modal
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {GatewayInformationStrings.FullMsgAssetDeletedSuccessfully}
          </p>
        </GenericModal>
      )
    } else if (gatewayDeleteStatus.isLoading) {
      return (
        <GenericModal title={'Loading...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </GenericModal>
      )
    } else if (gatewayDeleteStatus.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {gatewayDeleteStatus.error} </p>
        </GenericModal>
      )
    } else if (gatewayDeleteStatus.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (gatewayDeleteStatus.httpStatus === httpStatus.ACCESS_FORBIDDEN_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {gatewayDeleteStatus.error} </p>
        </GenericModal>
      )
    }
  }

  return (
    <>
      <CardContent style={{ padding: '0px' }}>
        <Grid style={{display : 'flex'}}>
          <div>
            <div style={{ padding: '10px', backgroundColor: '#303030', height: 'fit-content', borderRadius: '10px', width: 'fit-content' }}>
              <img
                src={props.imageBinaryData && props.imageBinaryData.binaryData
                  ? `data:image/jpeg;base64,${props.imageBinaryData.binaryData}`
                  : DefaultImage}
                alt="Preview" style={{ width: '136px', height: '136px' }}
              />
            </div>
          </div>
          <div style={{display: 'contents'}} >
            <Grid container>
              <Grid container xs={12} sm={11} style={{ paddingLeft: '20px' }}>
                <Grid item xs={12} sm={12}>
                  <Grid>
                    <span style={{ fontSize: 'small', fontWeight: '600' }}>
                      {GatewayInformationStrings.GatewayInformation}
                    </span>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <Grid>{GatewayInformationStrings.Name}</Grid>
                    <Grid>{formatTextWithTooltip(props?.gatewayInfo?.gatewayInfo?.name)}</Grid>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Grid>{GatewayInformationStrings.CreatedOn}</Grid>
                    <Grid>
                      {props?.gatewayInfo?.gatewayInfo !== null && props?.gatewayInfo?.gatewayInfo?.install_date !== null && props?.gatewayInfo?.gatewayInfo?.install_date !== '' ? moment.utc(props?.gatewayInfo?.gatewayInfo?.install_date).tz(userTimezone).format('hh:mm A, MMM DD YYYY') : ''}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Grid>{GatewayInformationStrings.Description}</Grid>
                    <Grid>{formatTextWithTooltip(props?.gatewayInfo?.gatewayInfo?.description)}</Grid>
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginLeft: 'auto', position: 'relative' }}>
                    <IconButton
                      aria-haspopup="true"
                      aria-controls={open ? 'fade-menu' : undefined}
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                      sx={{ padding: '0px !important', position: 'absolute', top: 0, right: 0 }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="fade-menu"
                      MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={handleEdit} style={{ color: '#64c3ff', textDecoration: 'none' }}>Edit</MenuItem>
                      <MenuItem onClick={handleDelete} style={{ color: '#64c3ff', textDecoration: 'none' }}>Delete</MenuItem>
                    </Menu>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </CardContent>
      {confirmDeletePopup && (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={'Delete Gateway'}
          LabelPositive="Confirm"
          LabelNegative="Cancel"
          onClickPositive={handleDeleteCampaign}
          onClose={() => { setConfirmDeletePopup(false) }}
          onClickNegative={() => { setConfirmDeletePopup(false) }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {GatewayInformationStrings.DeleteConfirmation}<br/><br/>
            {GatewayInformationStrings.DeleteConfirmationWarning}
          </p>
        </GenericModal>
      )}
      {
        /* istanbul ignore next */
        showDeleteStatus && handleDeleteCampaignWithFailure()
      }
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  gatewayDeleteCampaign: (selectedGatewayId: string) => { dispatch(gatewayDeleteCampaign(selectedGatewayId)) }
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(GatewayInformation)
